module.exports = __webpack_public_path__ + "static/media/subtitle-icon.28f9eaae.svg";